import { InfoTextConfigModel, ProductConfigProps, SearchWordsConfigModel } from "models/WebShop";
import { useState } from "react";

const SearchWordsConfig = ({ config, handleOnChange, handleFormValidation }: ProductConfigProps<SearchWordsConfigModel>) => {

    const initialConfig = config?.[0];
    const maxLenght = 16000;

    const [searchWordsText, setInfoText] = useState(initialConfig?.searchWords ?? "")
    const [errorMessage, setErrorMessage] = useState("");
    const [copyText, setCopyText] = useState(false);
    const [invalidPhrase, setInvalidPhrase] = useState<string[]>([]);
    

    const validateInput = (input: string): boolean => {
        setCopyText(false);
        setErrorMessage("");
        setInvalidPhrase([]);
        let isValid = true;
        let invalidPhrases: string[] = [];

        if (input.trim().endsWith(",")) {
            setErrorMessage("Søkeord kan ikke avsluttes med komma.");
            isValid = false;
            return false;
        }

        const terms = input.split(",").map(term => term.trim()).filter(term => term.length > 0);

        for (const term of terms) {
            const wordCount = term.split(/\s+/).filter(word => word.length > 0).length;
            if (wordCount > 6) {
                invalidPhrases.push(term);
                isValid = false;
            }
        }
        setInvalidPhrase(invalidPhrases);
        return isValid;
    };

    const handleInputChange = (input: string) => {
        setInfoText(input);

        const isValid = validateInput(input);
        handleFormValidation(isValid);

        if (isValid) {
            const newConfig: SearchWordsConfigModel = {
                searchWords: input,
                crmPublishLineId: initialConfig.crmPublishLineId,
                crmProductId: initialConfig.crmProductId
            };
            handleOnChange([newConfig]);
        }
    };

    const copyToClipboard = () => {
        navigator.clipboard.writeText(searchWordsText);
        setCopyText(true);
        setTimeout(() => setCopyText(false), 2000);
    }


    return <>
        <p>Bli funnet når våre brukere søker etter ordene som representerer dine varer og tjenester.</p>
        <p className="text-muted">Legg inn søkeord separert med komma. Søkeord kan også være en frase med maks 6 ord. Søketreff i frase krever nøyaktig treff på alle ordene i frasen. Endringer på kjøpte produkter vil bli behandlet fortløpende før det vises på nett.</p>
        <textarea className="form-control border-primary border-opacity-50 mb-3" id="sokeord" aria-label="Søkeord" maxLength={maxLenght} onChange={(e) => handleInputChange(e.target.value)} placeholder="Placeholder" style={{ overflow: "hidden", height: "324px" }} value={searchWordsText}></textarea>
        {errorMessage && (
            <p className="text-danger mb-0">
                {errorMessage}
            </p>

        )}
        {invalidPhrase.length > 0 ? <><p className="text-danger mb-0">For mange ord i frase, maks 6 ord. Bruk komma for å dele fraser til flere søkeord. Husk at søketreff i frase krever nøyaktig treff på alle ordene i frasen:</p><ul className="text-danger">
            {invalidPhrase.map(p => <li>{p}({p.split(' ').length} ord)</li>)}</ul></> : null}
        {copyText ? <p className="a">Kopiert!</p> :<p className="a" onClick={copyToClipboard}>Kopier tekst</p> }

    </>

}

export default SearchWordsConfig;